import React, { FC, useCallback, useState } from 'react';

import { LIST_PAGE_SIZE } from 'utils/constants';
import { resqlExpertApi } from 'utils/api/resqlexpert';
import { usePaginatedOptions } from 'utils/usePaginatedOptions';
import useAutoSelect from 'utils/useAutoSelect';
import { ResqlExpertSubmissionListItem } from 'utils/api/resqlexpert.d';
import { ResqlExpertStyled } from 'components/ResqlExpert/styles';

import SubmissionsList from './SubmissionsList';
import Submission from './Submission';
import SubmissionForm from './SubmissionForm';

const Submissions: FC = () => {
  const [selectedId, setSelectedId] = useState<number | undefined>(undefined);
  const [isFormOpen, setIsFormOpen] = useState(false);

  const fetchSubmissions = useCallback(
    ({ name, page, size, signal }: { name?: string; page: number; size: number; signal?: AbortSignal }) =>
      resqlExpertApi.listIntervener({ query: name, page, size, signal }),
    [],
  );

  const list = usePaginatedOptions<ResqlExpertSubmissionListItem>({
    fetch: fetchSubmissions,
    pageSize: LIST_PAGE_SIZE,
  });

  useAutoSelect(list.options, selectedId, setSelectedId);

  return (
    <ResqlExpertStyled>
      <SubmissionsList
        items={list.options}
        hasMore={list.hasMore}
        loading={list.loading}
        error={list.error}
        loadMore={list.loadMore}
        retry={list.retry}
        selectedId={selectedId}
        setSelectedId={setSelectedId}
        query={list.search}
        setQuery={list.setSearch}
        onAdd={() => setIsFormOpen(true)}
      />
      <Submission id={selectedId} />
      <SubmissionForm
        isOpen={isFormOpen}
        onClose={() => setIsFormOpen(false)}
        fetchData={list.refresh}
        onCreated={(created) => setSelectedId(created.id)}
      />
    </ResqlExpertStyled>
  );
};

export default Submissions;
